class FetchAccountUsers {
	constructor(
		public readonly accountId: number,
		// Already composed by the `UserFilterView` (`page`, `rows`, `search`, `roleId`, `facilityId`,
		// `isActive`, `pendingInvitation`, sort) — this Query does not know the filter shape.
		public readonly queryParams: URLSearchParams,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		return this.queryParams.toString();
	}
}

export default FetchAccountUsers;
